var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditAttributes32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.582 11l-1 1H3v-1zM3 6h25V5H3zm0 11v1h12.582l1-1zm7.548 6.034l.034-.034H3v1h6.978l.146-.34a2.003 2.003 0 0 1 .424-.626zm20.804-12.688a1.203 1.203 0 0 1 .037 1.727l-1.8 1.8-.001-.001-14.101 14.102-5.465 2.342a.306.306 0 0 1-.403-.402l2.343-5.465L27.863 8.547a1.203 1.203 0 0 1 1.727.037zM14.495 27.311l-1.87-1.87-1.403 3.273zm14.12-13.88l-2.11-2.11L13.21 24.612l2.112 2.111zm2.03-2.377l-1.761-1.762a.285.285 0 0 0-.193-.092.163.163 0 0 0-.12.054l-1.36 1.36 2.111 2.11 1.36-1.359c.133-.133-.02-.294-.037-.311z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAttributes32);
export default __webpack_public_path__ + "static/media/edit-attributes-32.7a19078740cf02f78b5f6df3ca00a698.svg";
export { ForwardRef as ReactComponent };